// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xuetB56X6pJVqe {
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 272px;
  margin-bottom: 30px;
  padding: 25px 30px 30px;
  border: 1px solid var(--ds-border, #091e4224);
  border-width: 1px 0;
}
.xuetB56X6pJVqe.PjVNdV9Y869_bi {
  border-bottom-width: 0;
}
@media only screen and (min-width: 751px) and (max-width: 900px), only screen and (max-width: 750px) {
  .xuetB56X6pJVqe {
    flex-direction: column-reverse;
    padding: 20px;
  }
}
.xuetB56X6pJVqe .IeBgAKbbN_QjuF {
  margin-right: 30px;
}
@media only screen and (min-width: 751px) and (max-width: 900px), only screen and (max-width: 750px) {
  .xuetB56X6pJVqe .IeBgAKbbN_QjuF {
    margin-right: 0;
    text-align: center;
  }
}
.xuetB56X6pJVqe .IeBgAKbbN_QjuF .EAafEKJ43N9oTV {
  margin-top: 40px;
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
}
.xuetB56X6pJVqe .IeBgAKbbN_QjuF .wrrq1pKFGCM7iP {
  margin-top: 24px;
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  letter-spacing: -0.006em;
  line-height: 20px;
  font-weight: var(--ds-font-weight-semibold, 600);
  font-weight: var(--ds-font-weight-regular, 400);
  margin-bottom: 20px;
  line-height: 24px;
}
.xuetB56X6pJVqe .IeBgAKbbN_QjuF .XRz8UCMW_adyYx {
  margin-left: 16px;
  color: var(--ds-text-subtle, #44546f);
}
@media only screen and (min-width: 751px) and (max-width: 900px), only screen and (max-width: 750px) {
  .xuetB56X6pJVqe .IeBgAKbbN_QjuF .XRz8UCMW_adyYx {
    width: 100%;
  }
}
.xuetB56X6pJVqe .IeBgAKbbN_QjuF .hwILwza5_fsk3N {
  text-decoration: none;
}
.xuetB56X6pJVqe .IeBgAKbbN_QjuF .y5aEBNbfuMaMpp {
  padding: 10px 18px;
  white-space: nowrap;
}
@media only screen and (min-width: 751px) and (max-width: 900px), only screen and (max-width: 750px) {
  .xuetB56X6pJVqe .IeBgAKbbN_QjuF .y5aEBNbfuMaMpp {
    width: 100%;
    margin-bottom: 20px;
  }
}
.xuetB56X6pJVqe .eWmr_qyLzmZTFA {
  width: 100%;
  max-width: 323px;
}
@media only screen and (min-width: 751px) and (max-width: 900px), only screen and (max-width: 750px) {
  .xuetB56X6pJVqe .eWmr_qyLzmZTFA {
    max-width: 260px;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"whatIsTrelloBanner": `xuetB56X6pJVqe`,
	"last": `PjVNdV9Y869_bi`,
	"content": `IeBgAKbbN_QjuF`,
	"heading": `EAafEKJ43N9oTV`,
	"description": `wrrq1pKFGCM7iP`,
	"learnMoreLink": `XRz8UCMW_adyYx`,
	"buttonLink": `hwILwza5_fsk3N`,
	"signupButton": `y5aEBNbfuMaMpp`,
	"boardimage": `eWmr_qyLzmZTFA`
};
export default ___CSS_LOADER_EXPORT___;
